<section class="centered-with-padding py-7">
  <div class="rounded-[20px] bg-gray-light px-9 py-8">
    <div class="flex flex-col items-center gap-x-24 gap-y-9 desk:flex-row">
      <app-title [title]="{ text: data.title, as: 'span' }" class="block desk:max-w-[260px]" size="h2" />
      <div class="grid w-full grow grid-cols-1 gap-4 desk:grid-cols-2">
        @for (link of data.links; track $index) {
          @let cta = link.cta;
          <div (click)="onLinkClick(cta.label, $index)" class="block h-[229px]">
            <a [appLink]="cta.url">
              <app-option-card [image]="link.image" [isPriority]="!isImageInPreviousBlocks && $index < 3">
                <div card-title-left>{{ cta.label }}</div>
                <app-svg [height]="24" [width]="24" card-title-right src="assets/icons/arrow-right.svg" />
              </app-option-card>
            </a>
          </div>
        }
      </div>
    </div>
  </div>
</section>
